import Component from '../core/Component'
import withScroll from '../core/withScroll'
import Scroll from '../services/Scroll'
import withMedia from "../core/withMedia"

export class RolePageHeader extends Component {
    constructor(element, options = {}) {
        super(element, options)

        this.ref = {
            inner: null
        }
    }

    prepare() {
    }

    scroll(ratio) {
        this.render(ratio)
    }
    render(ratio) {
        const scrollY = Scroll.getScroll().y

        this.ref.inner.style.transform = `translateY(${scrollY - ratio * -50}px) scale(${1 + ratio * .5})`
        const opacityRatio = ratio
        this.ref.inner.style.opacity = 1 - opacityRatio
    }

}

export default withMedia(withScroll(RolePageHeader))
